import { mapState } from "vuex";
import Address from "../../../address/address.vue";

export default {
  data() {
    return {
      list: [],
      index: 0,
      pageTotal: 0,
      searchVal: "",
      addressVisible: false,
      pageNum: 1,
      params: "",
    };
  },

  components: {
    Address,
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.$store.dispatch("member/member/queryDeliveryList", { pageSize: 10, pageNum: this.pageNum, params: this.params }).then((res) => {
        this.list = res.memberDeliveryList;
        this.pageTotal = res.totalCount;
      });
    },
    query() {
      this.pageNum = 1;
      this.loadData();
    },
    // 修改状态
    receiveChange(index, arg, $form) {
      console.log(arg);
      const { list = [] } = this;
      const { deliveryId = null, addr, isDefault = 0, areaId, areaAxis, name, tel } = list[index] || {};
      this.$store
        .dispatch(
          "member/member/editDelivery",
          this.$qs.stringify(
            arg
              ? {
                  deliveryId,
                  isDefault,
                  ...arg,
                }
              : {
                  deliveryId,
                  tel,
                  addr,
                  name,
                  areaId,
                  areaAxis,
                  isDefault,
                }
          )
        )
        .then((res) => {
          if (res.code != "0") {
            this.$message.error(res.msg);
            throw new Error(res.msg);
          }
          $form.resetFields();
          this.$message.success(res.msg || "编辑成功");
          this.addressVisible = false;
          this.loadData();
        });
    },

    // 修改自定义地址
    addressChange(index) {
      this.index = index;
      this.addressVisible = true;
    },
    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.loadData();
    },
    // 修改自定义地址确定
    addressConfirm(form, $form) {
      const { index } = this;
      try {
        this.receiveChange(
          index,
          {
            ...form,
          },
          $form
        );
      } catch (e) {
        console.log("eeee: ", e);
        return false;
      }
      console.log("修改地址aaa：", form);
    },
    delAddress(deliveryId) {
      this.$store.dispatch("member/member/delDelivery", this.$qs.stringify({ deliveryId })).then((res) => {
        this.$message.success(res.msg || "删除成功");
        this.loadData();
      });
    },
    editDefault(item) {
      const { deliveryId, isDefault } = item;
      this.$store.dispatch("member/member/editDelivery", this.$qs.stringify({ deliveryId, isDefault })).then((res) => {
        if (res.msg) {
          this.$message.success(res.msg);
        }
        this.loadData();
      });
    },
  },
};
